export default __webpack_public_path__ + "static/media/pot2-big.173de0b2.jpg";